import { t } from '@lingui/macro';

const currencyCodeOptions = () => [
  {
    label: t`Euro`,
    value: 'EUR',
  },
  {
    label: t`Gulden`,
    value: 'NLG',
  },
  {
    label: t`Britse pond`,
    value: 'GBP',
  },
  {
    label: t`Amerikaanse dollar`,
    value: 'USD',
  },
  {
    label: t`Braziliaanse real`,
    value: 'BRL',
  },
];

export default currencyCodeOptions;
